<template>
  <div class="min-h-screen flex items-center justify-center px-4">
    <div class="text-center max-w-md">
      <h1 class="text-8xl font-bold text-primary-600 mb-4">{{ error?.statusCode || 500 }}</h1>
      <h2 class="text-2xl font-bold text-primary-900 mb-2">
        {{ error?.statusCode === 404 ? $t('error.pageNotFound') : $t('error.somethingWentWrong') }}
      </h2>
      <p class="text-primary-500 mb-6">
        {{ error?.message || $t('error.unexpectedError') }}
      </p>
      <div class="flex gap-3 justify-center">
        <button @click="handleError" class="btn btn-primary px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700">
          {{ error?.statusCode === 404 ? $t('error.goHome') : $t('error.tryAgain') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  error: { statusCode: number; message: string } | null;
}>();

function handleError() {
  if (props.error?.statusCode === 404) {
    navigateTo('/');
  } else {
    clearError({ redirect: '/' });
  }
}
</script>
